import React from 'react';
import clsx from 'clsx';

export interface MobileSheetProps {
  children: React.ReactNode;
  className?: string;
  /** Show drag handle pill at top (default true). */
  showHandle?: boolean;
  role?: string;
  'aria-label'?: string;
  'aria-labelledby'?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const MobileSheet: React.FC<MobileSheetProps> = ({
  children,
  className,
  showHandle = true,
  role = 'dialog',
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  onClick,
}) => (
  <div
    className={clsx(
      'mobile-sheet gt-keyboard-sheet',
      className,
    )}
    role={role}
    aria-modal="true"
    aria-label={ariaLabel}
    aria-labelledby={ariaLabelledBy}
    onClick={onClick}
  >
    {showHandle ? (
      <div className="mobile-sheet__handle" aria-hidden="true">
        <div className="mobile-sheet__handle-pill" />
      </div>
    ) : null}
    {children}
  </div>
);

export default MobileSheet;
